import {Box, styled} from "@mui/material";
import React from "react";
import {Title} from "../Contacts/Contacts";
import {DownloadButton} from "../ExecutiveSummary/ExecutiveSummary";
import UseCasesScenarios from "./UseCasesScenarios";
import UseCasesTryTo from "./UseCasesTryTo";
import WebIcon from "@mui/icons-material/Web";

const UseCasesContainer = styled(Box)({
    position: "relative",
    background: "radial-gradient(circle at -30% 80%, #6d7a83 0%,transparent 36%), radial-gradient(circle at 143% 10%, #6d7a83 0%,transparent 66%), #020508",
    borderImage: "linear-gradient(90deg, #05080c, #6d7985, #05080c) 100",
    borderBottom: "2px solid",
    "@media(max-width: 768px)":{
        background: "linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.5))",
    }
});

const UseCasesHeader = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "20px",
    boxSizing: "border-box",
});

const UseCases = ():JSX.Element => {
    return (
        <UseCasesContainer>
            <UseCasesHeader>
                <Title>
                Interactive Examples:
                </Title>
                {window.innerWidth > 1024 && <DownloadButton onClick={() => {window.open("https://inside-questor.web.app/");}}>
                    <WebIcon htmlColor={"#FFFFF"}/>
                Explore Presentation Demo App
                </DownloadButton>}
            </UseCasesHeader>
            <UseCasesTryTo/>
            <UseCasesScenarios/>
        </UseCasesContainer>
    );
};

export default UseCases;
